// extracted by mini-css-extract-plugin
export default {"container":"SkeletonItem-container-27S","item":"SkeletonItem-item-17o","image":"SkeletonItem-image-1nx","info":"SkeletonItem-info-2oZ","footer":"SkeletonItem-footer-2j4"};